import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';

@Component({
  selector: 'form-text',
  templateUrl: './form-text.component.html',
  styleUrls: ['./form-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextComponent),
      multi: true,
    },
  ],
})
export class FormTextComponent implements ControlValueAccessor {
  @Input() control: FormControl = new FormControl();
  @Input() label: string = '';
  @Input() help: string = '';
  @Input() showErrors: boolean = false;
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() name: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() maxlengthSize: number | null = null;
  @Input() minlength: number | null = null;
  @Input() pattern: string = '';
  @Input() autocomplete: string = '';
  @Input() class: string = '';
  @Input() id: string = '';

  value: any = '';
  touched: boolean = false;

  // ControlValueAccessor implementation
  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: any): void {
    const value = event.target.value;
    this.value = value;
    this.onChange(value);

    // Update the external control if provided
    if (this.control) {
      this.control.setValue(value);
    }
  }

  onBlur(): void {
    this.touched = true;
    this.onTouched();

    // Mark the external control as touched if provided
    if (this.control) {
      this.control.markAsTouched();
    }
  }

  onFocus(): void {
    if (!this.touched) {
      this.touched = true;
    }
  }

  // Helper method to check if control has errors
  hasError(errorType: string): boolean {
    return this.control && this.control.errors && this.control.errors[errorType];
  }

  // Helper method to check if control is invalid and should show errors
  shouldShowErrors(): boolean {
    return this.showErrors && this.control && this.control.invalid && this.control.touched;
  }
}
